// DataReview.tsx
import React, { useEffect, useState } from 'react';
import CommentReviewTable from './CommentReviewTable'; // Adjust the import path as needed
import CommentsSummary from './CommentsSummary'; // Import the CommentsSummary component
import { PCARCommentInfo } from './DataReview.interfaces';
import { PageTitle } from '../PageStyles'; // Import the PageTitle component
import useApi from '../api/axiosAdapter';
import LoadingOverlay from '../Spinner/LoadingOverlay'; // Import the LoadingOverlay component
import { useAuth } from '../Authorization/AuthContext';

const DataReview: React.FC = () => {
  const [allComments, setAllComments] = useState<PCARCommentInfo[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { get } = useApi();
  const { selectedProject } = useAuth();

  // Fetch table data from API
  const fetchData = async () => {
    if (!selectedProject) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      interface PCARCommentsListResponse {
        status: string;
        all_comments: PCARCommentInfo[];
        message?: string;
      }
      const response = await get<PCARCommentsListResponse>('pcar/comments_list');
      if (response && response.data) {
        const { status, all_comments, message } = response.data;
        setAllComments(all_comments || []);
        if (status && status !== 'success') {
          console.error('API error:', message);
        }
      } else {
        console.error('API response data is missing or undefined.');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setAllComments([]); // Clear comments on error
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProject]);

  return (
    <div>
      <PageTitle>Agency Review</PageTitle>
      {loading ? (
        <LoadingOverlay message="Loading comments..." />
      ) : !selectedProject ? (
        <div style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
          Please select a project from the dropdown above to view data.
        </div>
      ) : (
        <>
          <CommentsSummary data={allComments} />
          <h3>Comment Table</h3>
          <CommentReviewTable data={allComments} onDataChange={fetchData} />
        </>
      )}
    </div>
  );
};

export default DataReview;